export default __webpack_public_path__ + "static/media/people_on_rocket.c692a3b5.svg";